import React, { useState } from "react";
import { Box, Typography, TextField, Alert } from "@mui/material";
import { useCompletedSchedules } from "services/hooks/rentals";
import CompletedSchedulesTable from "components/Tables/CompletedSchedulesTable";

const CompletedSchedules = () => {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  
  const { 
    completedSchedules, 
    totalCount, 
    isLoading, 
    error, 
    updateOutstandingBalance 
  } = useCompletedSchedules(search, true, true, page, pageSize);

  const handleUpdateBalance = async (id, newBalance) => {
    const success = await updateOutstandingBalance(id, newBalance);
    if (success) {
      setAlertMessage("Balance updated successfully");
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 3000);
    } else {
      setAlertMessage("Failed to update balance");
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 3000);
    }
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (newPageSize) => {
    setPageSize(newPageSize);
  };

  return (
    <Box m="10px">
      <Box container spacing={2}>
        <Box item xs={12}>
          <Typography
            variant="h4"
            gutterBottom
            sx={{ fontWeight: "bold", mb: 5, fontSize: 25 }}
          >
            Completed Schedules
          </Typography>

          {showAlert && (
            <Alert 
              severity={alertMessage.includes("success") ? "success" : "error"}
              sx={{ mb: 2, borderRadius: "2rem" }}
            >
              {alertMessage}
            </Alert>
          )}

          <TextField
            label="Search"
            variant="outlined"
            fullWidth
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            sx={{ mb: 2 }}
          />

          <CompletedSchedulesTable
            data={completedSchedules}
            totalCount={totalCount}
            loading={isLoading}
            error={error}
            onUpdateBalance={handleUpdateBalance}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default CompletedSchedules; 